import React, { useState,useEffect } from 'react';
import { useRef } from 'react';
import { ToastContainer, toast, Icons } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './RightSide.css';
import SwitchExample from './tooglebtn';
import Switch from "react-switch";
import { useSearchParams } from "react-router-dom";
import jwt_decode from "jwt-decode";
import axios from 'axios' ;
import { decodeChecker } from "../utils/helper/index";


const RightComponent = ({ arg: {user, setUser, handleSubmit,value1, setValue1, value2, setValue2, urlvalue, setUrlValue, checked, setChecked}}) => {
    const [status, setStatus]=useState(false);
    
    const onHandleChange = (e) =>{
     setValue1(e.target.value);
    } 
    const onHandleChange2 = (e) => {
     setValue1(value1 + e.target.value) 
    }
   // console.log(value1);


    const onHandleChange3 = (e) =>{
      setValue2(e.target.value);
     } 
     const onHandleChange4 = (e) => {
      setValue2(value2 + e.target.value) 
     }
     //console.log(value2);

     const inputRef = useRef(null);
     const onUrlHandleChange = (e) =>{
      setUrlValue(e.target.value);
    } 
   // console.log(urlvalue);

    const onClearInput = () => {
      inputRef.current.value = "";
    };

    const [checked2, setChecked2] = useState(true);
  
      let [searchParams] = useSearchParams();
      const code = sessionStorage.getItem("code");
      //console.log(code);
      var decoded = jwt_decode(code);
      // console.log("token=>", decoded.jwttoken);
  
      const shopname = decoded.jwttoken;
  
      const url = "https://tabicon.ens.enterprises/getshop";
      // const [user1, setuser1] = useState({
      //     shop:shopname
      //   });
    useEffect(() => {
        axios.post(url, {
          shopify_domain:shopname,
        })
        .then(({data})=>{
          const {firsttext, secondtext, icon , enable, faviconUrl} = data;
          setUser({...user, 
            firsttext,
            secondtext,
            icon,
            enable,
            faviconUrl
          });

          // console.log("from here =>", data);

        });   
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);
       // console.log("helloo first =====>",user.firsttext); 

    // const toggle = (e)=>{
    //   console.log((!status));
    //   setStatus({...status, [e.target.name]:e.target.value})
    // }
    const alertMsg =(e)=>{
      if(setStatus){

      }
      toast.success('Successful'); 
    }

    const handleChange = () => {  
      setUser({...user, enable: user.enable == "true" ? "false" : "true"});
      // console.log("checked----", user.enable);
    }
    // console.log(checked);
    // console.log(user.enable);
  
  const inputHandler = (e)=>{
    setUser({...user, [e.target.name]:e.target.value});
  }

///disble_item
  return (
    <React.Fragment>
    <div className='col-lg-8 col-md-8 col-sm-6 right_side text-dark bg-light' id="deep-color">
    <form onSubmit={(e)=> { handleSubmit(e);alertMsg()}} class="needs-validation" novalidate>
    <div className='container text-center'>
      <label><h2 className='text-center'>Setting</h2></label>
      <div className="form-switch">

        {/* <SwitchExample checked2={checked2} setchecked2={setChecked2} checked={checked} setchecked={setChecked} onChange={(e)=>{setUser({...user, [e.target.name]:e.target.value})}} setUser={setUser} user={user} /> */}


        <label> 
        <Switch onChange={()=>handleChange()} checked={user.enable == "true" ? true : false} />
      </label>


      
    </div>
      
     <div className='row d-flex'>
        <div className="row d-flex">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="form-group text-start mb-3">
          <label className='text-start' HtmlFor="formGroupExampleInput" for="validationCustom01">First Text</label>
            <input type="text" className={ `form-control ${user.enable == "true" ? null : "disble_item"}` } id="validationCustom01" required placeholder=".." onChange={(e)=> inputHandler(e) } name="firsttext" value={user.firsttext} />

            <div class="invalid-tooltip">
              Please choose a unique and valid username.
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="form-group mb-3">
          <label HtmlFor="" for="validationCustom02"></label>
            <select className={ `form-select ${user.enable == "true" ? null : "disble_item"}` } name="firsttextEmoji" id="validationCustom02" required onChange={(e)=>  setUser({...user, firsttext: user.firsttext+" "+e.target.value}) } aria-label="Floating label select example" value={user.firstTextEmoji} >
              <option className='justify-content-end text-muted' value="" disabled>Choose the icon</option>
              <option value="😍" >😍</option>
              <option value="💓" >💓</option>
              <option value="💞" >💞</option>
              <option value="🌠" >🌠</option>
              <option value="🌹" >🌹</option>
              <option value="😘" >😘</option>
              <option value="😅" >😅</option>
              <option value="😂" >😂</option>
              <option value="🗽" >🗽</option>
              <option value="🗼" >🗼</option>
              <option value="🗻" >🗻</option>
            </select>
          </div>
        </div>
      </div>

      <div className="row d-flex">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="form-group text-start mb-3">
          <label className="" HtmlFor="formGroupExampleInput" for="validationCustom03">Second Text</label>
            <input type="text" className={ `form-control ${user.enable == "true" ? null : "disble_item"}` } id="validationCustom03" placeholder="me" required onChange={(e)=>inputHandler(e)} name="secondtext" value={user.secondtext} />
            <div class="invalid-feedback">
              Please choose a username ..
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="form-group mb-3">
          <label HtmlFor="" for="validationCustom04"></label>
            <select className={ `form-select ${user.enable == "true" ? null : "disble_item"}` } id="validationCustom04" required onChange={(e)=> setUser({...user, secondtext: user.secondtext+" "+e.target.value})} name="secondtextEmoji" aria-label="Floating label select example" value={user.secondTextEmoji} >
            <option className='justify-content-end text-muted' value="" disabled>Choose the icon</option>
              <option value="😍" >😍</option>
              <option value="💓" >💓</option>
              <option value="💞" >💞</option>
              <option value="🌠" >🌠</option>
              <option value="🌹" >🌹</option>
              <option value="😘" >😘</option>
              <option value="😅" >😅</option>
              <option value="😂" >😂</option>
              <option value="🗽" >🗽</option>
              <option value="🗼" >🗼</option>
              <option value="🗻" >🗻</option>
            </select>
          </div>
        </div>
      </div>

      <div className="row d-flex">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="form-group mb-3">
          <label HtmlFor=""></label>
            <select className={ `form-select ${user.enable == "true" ? null : "disble_item"}` } name="icon" id="validationCustom05" onChange={(e)=> inputHandler(e) } aria-label="Floating label select example" value={user.icon} onClick={onClearInput}>
            <option className='justify-content-end text-muted' value="" selected>Choose the icon</option>
            <option className='justify-content-end' value="https://tabicon.ens.enterprises/asset/images/Maple.ico">
              Maple &#127809;
            </option>
            <option className='justify-content-end' value="https://tabicon.ens.enterprises/asset/images/Partypopper.ico">
            Partypopper &#x1F389;</option>
            <option className='justify-content-end' value="https://tabicon.ens.enterprises/asset/images/Halloween.ico">Halloween &#127875; </option>
            <option className='justify-content-end' value="https://tabicon.ens.enterprises/asset/images/Flag.ico">Flag &#x1F1E8;&#x1F1F5; </option>
            <option className='justify-content-end' value="https://tabicon.ens.enterprises/asset/images/Heartgift.ico">Heartgift &#128157;</option>
            <option className='justify-content-end' value="https://tabicon.ens.enterprises/asset/images/Blackheart.ico">Blackheart &#128420;</option>
            <option className='justify-content-end' value="https://tabicon.ens.enterprises/asset/images/icon.png">Bell &#128276;</option>
            <option className='justify-content-end' value="https://tabicon.ens.enterprises/asset/images/Stethscope.ico">Stethoscope &#129658;</option>
            <option className='justify-content-end' value="https://tabicon.ens.enterprises/asset/images/Tree.ico">Tree &#127876;</option>
            <option className='justify-content-end' value="https://tabicon.ens.enterprises/asset/images/Pill.ico">Pill &#128138;</option>
            </select>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="form-group text-start mb-3">
          <label HtmlFor="formGroupExampleInput">Favicon Url</label>
            <input type="url" className={ `form-control ${user.enable == "true" ? null : "disble_item"}` } name="faviconUrl" id="validationCustom06" placeholder="https://www.ens.enterprises/" value={user.faviconUrl} onChange={(e)=> inputHandler(e) }  ref={inputRef}/>
{//             <div className='row d-flex text-muted'>*if you want set your favicon then url should be this formate <br/>"https://www.example.com/favicon.ico".</div>
       }</div>
        </div>
      </div>
      <div className='row g-2'>
        <div className="d-grid gap-2 col-6 mx-auto">
          <button type='submit' className='btn rounded-pill btn-colour'>Submit</button>       
        </div>
      </div>      
        </div>

     </div> 
     </form>  
    </div>
    <ToastContainer/>
    </React.Fragment>
    
  )
}
export default RightComponent;
